import { Post } from "../models/post";
import { formatDateFullWithOrdinal } from "./sharedService";

export const getWeekdaysFromPosts = (posts: Post[]): string => {
    const weekdayFormatter = new Intl.DateTimeFormat('en-GB', { weekday: 'long' });

    // Create a Set to store unique weekday names
    const weekdays = new Set<string>();

    posts.forEach(post => {
      const date = new Date(post.post_date);
      const weekday = weekdayFormatter.format(date);
      weekdays.add(weekday);
    });

    // Convert the set to an array and sort by actual weekday order
    const orderedWeekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const sorted = Array.from(weekdays).sort(
      (a, b) => orderedWeekdays.indexOf(a) - orderedWeekdays.indexOf(b)
    );

    // Return comma-separated list
    return sorted.join(', ');
  };

  // 1️⃣ Group posts by formatted date string
  export const groupPostsByDate = (posts: Post[]): Record<string, Post[]> => {
    return posts.reduce((acc, post) => {
      const formattedDate = formatDateFullWithOrdinal(post.post_date, true, false);
      if (!acc[formattedDate]) acc[formattedDate] = [];
      acc[formattedDate].push(post);
      return acc;
    }, {} as Record<string, Post[]>);
  };
